// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2hKES","red":"styles_red__V3WKd","white":"styles_white__274nN"};